










































import Vue from 'vue';
import {
	MIN_SENTENCES,
	MIN_LETTERS,
	MIN_WORDS,
	MAX_SENTENCES,
	MAX_LETTERS,
	MAX_WORDS,
} from '@/constants';

export default Vue.extend({
	name   : 'BookFilters',
	data() {
		return {
			MIN_SENTENCES,
			MIN_LETTERS,
			MIN_WORDS,
			MAX_SENTENCES,
			MAX_LETTERS,
			MAX_WORDS,
			sentencesPerParagraph: this.$route.params.sentencesPerParagraph,
			wordsPerSentence     : this.$route.params.wordsPerSentence,
			minWordLength        : this.$route.params.minWordLength,
		};
	},
	methods: {
		handleSentenceChange($event: Event) {
			this.$router.push({
				params: {
					sentencesPerParagraph: ($event.target as HTMLInputElement).value,
				},
			});
		},
		handleWordChange($event: Event) {
			this.$router.push({
				params: {
					wordsPerSentence: ($event.target as HTMLInputElement).value,
				},
			});
		},
		handleLetterChange($event: Event) {
			this.$router.push({
				params: {
					minWordLength: ($event.target as HTMLInputElement).value,
				},
			});
		},
	},
});
